// TextField.tsx
import React, { ChangeEvent } from 'react';
import styles from './TextField.module.css';

interface TextFieldProps {
  name: string;
  value: string | number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  type?: string;
  placeholder?: string;
  error?: string;
  className?: string;
}

export const TextField: React.FC<TextFieldProps> = ({
  name,
  value,
  onChange,
  label,
  type = 'text',
  placeholder,
  error,
  className,
}) => {
  return (
    <div className={styles.container}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`${styles.input} ${error ? styles.error : ''} ${className || ''}`}
      />
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};
